import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import ImageFetchFailed from './ImageFetchFailed';
import measuredTextWidth from './measuredTextWidth';

export default function ImageLoadingStatus({ status, wrapperWidth, imageId }) {
  let fetchStatus = status;
  let loadingText ="Loading...";
  let textWidth = measuredTextWidth(loadingText,8);

  let loadingContent;

  if(  textWidth >= wrapperWidth ){
    loadingContent = <HourglassEmptyIcon style={{fontSize:14}}/> 
  }else if( fetchStatus === "pending"){
    loadingContent = (
      <div item={"image-fetch-status-text"} itemFetchStatus={"pending"}>
        Loading...
      </div>
    )

  }else if( fetchStatus === "corrupt" ){
    loadingContent = <ImageFetchFailed {...{
      message:"Resource not found.",
      imageId
    }}/>
  }else if( fetchStatus === "failed" ){
    loadingContent = <ImageFetchFailed {...{
      canClickToRetryDownload: false,
      imageId
    }}/>
  } 
  if (fetchStatus !== "success") {
    return (
      <div style={{fontSize:8,border:'1px solid #ddd', 
        height:'100%',
        width:'100%', 
        textAlign:'center',
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
        }}>
        {loadingContent}
      </div>
    )
  }
  return null;
}
